module.exports = __webpack_public_path__ + "img/section-02.d03d93a8.png";